type BirthDateParts = {
  year: number | string;
  month: number | string;
  day: number | string;
};

/**
 * Formats a year/month/day triplet into an ISO `YYYY-MM-DD` date string,
 * zero-padding the month and day. Accepts numeric or string parts.
 */
export const formatDateOfBirth = (birthDate: BirthDateParts): string =>
  `${Number(birthDate.year).toFixed(0)}-${Number(birthDate.month).toFixed(0).padStart(2, '0')}-${Number(birthDate.day)
    .toFixed(0)
    .padStart(2, '0')}`;
